import HowItWorksStep from "./HowItWorksStep";
import { HOW_IT_WORKS_STEPS } from "../../domain/constants/constants";

export default function HowItWorksList() {
  return (
    <>
      <HowItWorksStep {...HOW_IT_WORKS_STEPS[0]} />
      <HowItWorksStep {...HOW_IT_WORKS_STEPS[1]} />
      <HowItWorksStep {...HOW_IT_WORKS_STEPS[2]} />
      <HowItWorksStep
        {...HOW_IT_WORKS_STEPS[3]}
        isLast
      />
    </>
  );
}